import React from 'react';
import DOMPurify from 'dompurify';

interface Props {
  crmNote: string;
}

export const CrmNoteDisplay = React.memo(({ crmNote }: Props) => {
  if (!crmNote) {
    return null;
  }

  const lines = crmNote.split('\n');
  const renderRow = (text: string) => (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
      className="pb-10"
    />
  );
  return (
    <>
      <div className="pencil-editor-header">Completed steps</div>
      <div className="data-table-container">
        <div className="pt-15 pb-15">{lines.map(renderRow)}</div>
      </div>
    </>
  );
});
